<template>
  <div>
    <div ref="spacer"></div>
    <div ref="nav" class="jf-nav">
      <div class="jf-nav__scroll">
        <span
          v-for="link in links"
          :key="link.id"
          :class="{ 'jf-nav__link--active': activeSection === link.id }"
          class="jf-nav__link"
          @click="scrollTo(link.id)"
        >{{ link.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeSection: 'event-details',
      triggerPoint: 0,
      isFixed: false,
      scrolling: false,
      links: [
        { id: 'event-details', label: 'Details' },
        { id: 'agenda', label: 'Agenda' },
        { id: 'speakers', label: 'Speakers' },
        { id: 'exhibitors', label: 'Exhibitors' },
        { id: 'jobs', label: 'Jobs' },
        { id: 'past-events', label: '2025 Highlights' },
        { id: 'register', label: 'Register' }
      ]
    };
  },
  methods: {
    getFixedOffset() {
      var offset = 0;
      var headerEl = document.getElementById('header-container');
      if (headerEl) {
        var pos = window.getComputedStyle(headerEl).position;
        if (pos === 'absolute' || pos === 'fixed') {
          offset += headerEl.offsetHeight;
        }
      }
      if (this.isFixed && this.$refs.nav) {
        offset += this.$refs.nav.offsetHeight;
      }
      return offset;
    },
    scrollTo(id) {
      var el = document.getElementById(id);
      if (!el) return;
      this.activeSection = id;
      this.scrolling = true;

      // Get current scroll from whichever element is actually scrolling
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var targetY = el.getBoundingClientRect().top + scrollTop;
      var self = this;

      $('html, body').stop().animate({ scrollTop: targetY }, 600, function() {
        if (self.scrolling) self.scrolling = false;
      });
    },
    onScroll() {
      var nav = this.$refs.nav;
      var spacer = this.$refs.spacer;
      if (!nav) return;

      var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      // Sticky logic
      if (!this.isFixed) {
        this.triggerPoint = spacer.getBoundingClientRect().top + scrollY;
      }

      var headerEl = document.getElementById('header-container');
      var headerH = 0;
      if (headerEl) {
        var pos = window.getComputedStyle(headerEl).position;
        if (pos === 'absolute' || pos === 'fixed') {
          headerH = headerEl.offsetHeight;
        }
      }

      if (scrollY + headerH >= this.triggerPoint && !this.isFixed) {
        var h = nav.offsetHeight;
        spacer.style.height = h + 'px';
        nav.style.position = 'fixed';
        nav.style.top = headerH + 'px';
        nav.style.left = '0';
        nav.style.right = '0';
        nav.style.zIndex = '1001';
        nav.style.boxShadow = '0 2px 15px rgba(0,0,0,0.1)';
        this.isFixed = true;
      } else if (scrollY + headerH < this.triggerPoint && this.isFixed) {
        spacer.style.height = '0';
        nav.style.position = '';
        nav.style.top = '';
        nav.style.left = '';
        nav.style.right = '';
        nav.style.zIndex = '';
        nav.style.boxShadow = '';
        this.isFixed = false;
      }

      // Active section tracking
      if (!this.scrolling) {
        var fixedOffset = this.getFixedOffset();
        for (var i = this.links.length - 1; i >= 0; i--) {
          var section = document.getElementById(this.links[i].id);
          if (section && section.getBoundingClientRect().top <= fixedOffset + 20) {
            this.activeSection = this.links[i].id;
            break;
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      var nav = this.$refs.nav;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.triggerPoint = nav.getBoundingClientRect().top + scrollTop;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.body.addEventListener('scroll', this.onScroll, { passive: true });
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    document.body.removeEventListener('scroll', this.onScroll);
  }
};
</script>

<style lang="scss" scoped>
.jf-nav {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
  z-index: 1001;

  &__scroll {
    display: flex;
    justify-content: center;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__link {
    display: block;
    padding: 16px 22px;
    color: #666;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    border-bottom: 3px solid transparent;
    transition: color 0.2s, border-color 0.2s;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      color: #2a41e8;
    }

    &--active {
      color: #2a41e8;
      border-bottom-color: #2a41e8;
    }
  }
}

@media (max-width: 768px) {
  .jf-nav {
    &__scroll {
      justify-content: flex-start;
      padding: 0 5px;
    }

    &__link {
      padding: 12px 14px;
      font-size: 13px;
    }
  }
}
</style>
